const doc = [({"se":({"models":({"school_class_course_module":({"new":"Ny", "completed":"Färdig", "doesnt_belong_to_the_same_course":"tillhör inte samma kurs: %{course_name}"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;